import React from "react";

export default function LargeLogo() {
    return <img src="/images/achieve-logo-lg.png" alt="coin" width="100%" />;
}
